<template>
  <div class="brandpage">
    <div class="mode">
      <div class="modetitle">
        <span class="title_span">品牌 / 公司</span>
        <router-link
          :to="{ path: '/jiaodian/brand/addBrand' }"
          class="item gopageA"
          >修改</router-link
        >
      </div>
      <div class="brand_tag">
        <span v-for="(item, index) in gzBrand">{{ item.title }}</span>
      </div>
    </div>
    <div style="height: 0.2rem; background-color: #f0f0f0"></div>
    <div class="mode">
      <div class="modetitle">
        <span class="title_span">关注的行业</span>
      </div>
      <!-- <div class="mode_search">
        <input placeholder="搜索行业" />
      </div> -->
      <div class="tags" v-for="(item, index) in hangYe">
        <div class="bigjiankang">{{ item.cat_title }}</div>
        <div class="brand_tag2">
          <span
            v-for="(item2, index2) in item.child"
            :key="index2"
            :data-id="item2.id"
            :data-pid="item2.pid"
            :class="item2.checked == 'true' ? 'activeli2' : 'noactiveli2'"
            @click="clickHy(item2.id, item2.pid, index2, index)"
            >{{ item2.cat_title }}</span
          >
          <!-- <span>免疫力</span>
          <span class="active_tag">益生菌</span>
          <span>小数</span>
          <span>儿童健康</span> -->
        </div>
      </div>
    </div>
    <div class="subTag">
      <div @click="overpage">完成</div>
    </div>
    <div style="height: 1.2rem;"></div>
  </div>
</template>

<script>
import {
  getHomeData,
  getShare,
  follow,
  getFollowLstNew,
  getArticleCateLstNew,
  getFollowFollowNew,
  getFollowCancelNew
} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {},
  props: {},
  data: function() {
    return {
      gzBrand: [], //存储我已关注的品牌列表
      gzHangye: [], //存储我已关注的行业
      hangYe: [], //存储行业
      gzHangyeIDs: [], //存储已关注行业id
      beforeUrl: ""
    };
  },
  created() {
    vm = this;
  },
  beforeRouteEnter(to, from, next) {
    var that = this;
    next(vm => {
      vm.beforeUrl = from.path;
    });
  },
  mounted: function() {
    vm.setOpenShare();
    this.getFollowLstNew();
  },
  methods: {
    // 获取行业列表
    getArticleCateLstNew() {
      var that = this;
      getArticleCateLstNew().then(res => {
        that.hangYe = res.data;
        for (var y = 0; y < that.gzHangye.length; y++) {
          that.gzHangyeIDs.push({
            id: that.gzHangye[y].pid,
            pid: that.gzHangye[y].id
          });
        }
        that.gzHangyeIDs = JSON.stringify(that.gzHangyeIDs);
        for (var i = 0; i < that.hangYe.length; i++) {
          for (var m = 0; m < that.hangYe[i].child.length; m++) {
            if (that.gzHangyeIDs.indexOf(that.hangYe[i].child[m].id) == -1) {
              that.hangYe[i].child[m].checked = "false";
              that.hangYe[i].child[m].pid = "";
            } else {
              var data = JSON.parse(that.gzHangyeIDs);
              for (var y = 0; y < data.length; y++) {
                if (data[y].id == that.hangYe[i].child[m].id) {
                  that.hangYe[i].child[m].pid = data[y].pid;
                  that.hangYe[i].child[m].checked = "true";
                }
              }
            }
          }
        }
      });
    },
    // 获取我关注的行业/品牌
    getFollowLstNew() {
      getFollowLstNew().then(res => {
        if (res.data) {
          this.gzHangyeIDs = [];
          this.gzBrand = res.data.brand;
          this.gzHangye = res.data.cate;
          this.getArticleCateLstNew();
        }
      });
    },
    clickHy(id, pid, index2, index) {
      var that = this;
      console.log("pid:", pid + "--------id:" + id);
      if (that.hangYe[index].child[index2].checked == "true") {
        getFollowCancelNew(pid)
          .then(res => {
            that.hangYe[index].child[index2].checked = "false";
            that.getFollowLstNew();
            // return this.$dialog.success(res.msg);
          })
          .catch(err => {
            // return this.$dialog.error(err.msg);
          });
      } else {
        getFollowFollowNew(id)
          .then(res => {
            that.hangYe[index].child[index2].checked = "true";
            that.getFollowLstNew();
            // return this.$dialog.success(res.msg);
          })
          .catch(err => {
            // return this.$dialog.error(err.msg);
          });
      }
      console.log(that.hangYe);
    },
    overpage() {
      // window.location.href = this.beforeUrl;
      window.location.href = "/";
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jdbeautycm.congwa.xyz",
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style>
body,
html {
  background-color: #fff !important;
}
.brandpage {
  position: relative;
  width: 100%;
}

.mode {
  width: calc(100% - 0.6rem);
  position: relative;
  margin: 0 auto;
}

.modetitle {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0;
}

.title_span {
  font-size: 0.36rem;
  color: #333;
  font-weight: bold;
  position: relative;
  padding-left: 0.15rem;
}

.title_span::before {
  content: "";
  display: block;
  width: 0.06rem;
  height: 0.3rem;
  background: #ff410a;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0.03rem;
}

.brand_tag {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: flex-start;
}

.brand_tag span {
  border: 0.03rem solid #ff410a;
  color: #ff410a;
  font-size: 0.24rem;
  padding: 0.06rem 0.18rem;
  border-radius: 0.3rem;
  margin-right: 0.16rem;
  margin-bottom: 0.2rem;
  min-width: 1rem;
  text-align: center;
}

.bigjiankang {
  color: #000;
  font-size: 0.32rem;
  padding: 0.4rem 0 0.2rem;
}

.brand_tag2 {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.brand_tag2 span {
  font-size: 0.24rem;
  border: 0.02rem solid #e2e2e2;
  display: block;
  height: 0.64rem;
  /* width: 1.5rem; */
  width: 22.5%;
  text-align: center;
  line-height: 0.64rem;
  border-radius: 0.1rem;
  margin-bottom: 0.2rem;
  margin-right: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand_tag2 span:nth-of-type(4n) {
  margin-right: 0;
}

.mode_search input {
  background-color: #f0f0f0;
  color: #999;
  font-size: 0.24rem;
  padding-left: 0.6rem;
  border-radius: 0.32rem;
  height: 0.64rem;
  width: 4rem;
  background-image: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/ico_search.png);
  background-position: 0.15rem center;
  background-repeat: no-repeat;
  background-size: 0.4rem 0.4rem;
}

.active_tag {
  background-color: #ff410a !important;
  color: #fff !important;
}

.subTag {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0.15rem 0;
  background-color: #fff;
  border-top: 0.02rem solid #f0f0f0;
  z-index: 9;
}

.subTag div {
  background-color: #ff410a;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  height: 0.8rem;
  line-height: 0.8rem;
  margin: 0 auto;
  width: 90%;
  border-radius: 0.1rem;
}

.activeli2 {
  background-color: #ff410a;
  color: #ffffff;
}

.noactiveli2 {
  background: #f6f6f6;
  color: #333;
}

.gopageA {
  color: #ff410a;
  padding-right: 0.3rem;
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_r.png)
    no-repeat;
  background-position: 100% center;
  background-size: 0.3rem 0.35rem;
  line-height: 2;
}
</style>
